import { Card, Button, Affix, Form } from "antd";
import { isMobileView } from "components/Common/AppHelper";
import Header from "components/Common/Header";
import { useNavigate } from "react-router-dom";
import NewTaskForm from "./NewTaskForm";

const AddNewTask = (props) => {
  const { width } = props;
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const discardForm = () => {
    navigate("/tanda/new-task");
  };

  const addNewTask = () => {
    form.submit();
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed" style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}>
          <Header
            title="Task"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button size="small" key={1} danger onClick={() => discardForm()}>
                Discard
              </Button>,
              <Button size="small" key={2} type="primary" onClick={() => addNewTask()}>
                Add Task
              </Button>,
            ]}
          />
        </Card>
      </Affix>

      <NewTaskForm form={form} />
    </>
  );
};

export default AddNewTask;
